import React, { Component } from 'react';
import { connect } from 'react-redux'
import { addTerm } from '../../../stores/actions/infoAction';

class TermAndCondition extends Component{
    
    constructor(props){
        super(props)
        this.state = {
            infoType:'TERM AND CONDITION',
            infoName:'',
            infoContent:'',
    
            isLoading: null,
            message: null,
        }
        this.baseState = this.state 
    }
    
    componentDidUpdate = (prevProps, prevState) => { 
        const { addTermError, addTermSuccess } = this.props;

        if(prevProps.addTermError !== addTermError) {
            this.setState({
                isLoading: false,
                message: {
                    msg: addTermError.message,
                    type: addTermError.type,
                }
            })
        }

        if(prevProps.addTermSuccess !== addTermSuccess) {
            this.setState({
                isLoading: false,
                message: {
                    msg: addTermSuccess.message,
                    type: addTermSuccess.type,
                }
            })
            setTimeout(() => { 
                this.setState(this.baseState)
                this.props.hide();
            }, 2000);
        }
    } 

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    addTerm = () => {

        var result = window.confirm("Confirm add?");

        if (result) {
            this.setState({
                isLoading: true
            })
            this.props.addTerm(this.state);
        }
    }

    render(){
        
        const { message, isLoading } = this.state;

        return(

        <div>

            <input type="text" id="infoName" onChange={this.handleChange.bind(this)} value={this.state.infoName} className="form-control" placeholder="Name"/>
        
            <textarea type="text" id="infoContent" onChange={this.handleChange.bind(this)} value={this.state.infoContent} className="form-control" placeholder="Content"/>
            
            { isLoading === true ? 
                <small>Loading...</small>
            : 
                message  ?
                    <small className={message.type === 'addTermError' ? "text-red" : message.type === 'addTermSuccess'  ? "text-green" : null }>
                        {message.msg}
                    </small>
                : null
            }

            <div className="mt-5 row justify-content-end">
                <button className="btn m-2 btn-outline-black" onClick={this.addTerm.bind(this)}><i className="fas fa-plus-circle"/>{' '}add term and condition</button>
            </div>
        </div>

        )
    }
}

const mapStateToProps = (state) => {
  return {
      addTermError: state.infos.addTermError,
      addTermSuccess: state.infos.addTermSuccess,
  }
}

const mapDispatchToProps = (dispatch) => {
    return {
      addTerm: (term) => dispatch(addTerm(term))
    }
}
  
export default connect(mapStateToProps, mapDispatchToProps)(TermAndCondition);